
export const customStyles = {
  content: {
    top: "50%",
    left: "50%",
    right: "auto",
    bottom: "auto", 
    marginRight: "-50%",
    transform: "translate(-50%, -50%)",
    background: "#fff",
    borderRadius: "25px",
    maxWidth: "40em",
    minHeight: "10em",
    padding:"1rm",
    width:  "35%" ,
  },
  overlay: {
    background: "#9e9e9e69",
  },
};

export const customStylesMobile = {
  content: {
    top: "50%",
    left: "50%",
    right: "auto",
    bottom: "auto", 
    marginRight: "-50%",
    transform: "translate(-50%, -50%)",
    background: "#fff",
    borderRadius: "25px",
    maxWidth: "40em",
    minHeight: "10em",
    padding:"1rm",
    width:  "90%" ,
  },
  overlay: {
    background: "#9e9e9e69",
  },
};

